import { FieldNames } from 'Src/constants/FieldNames'
import { remove } from 'lodash'
import { checkRequiredFields, FormErrors, formErrorState, FormValues } from 'Pages/ibro'
import { decimalRounded, DecimalRoundedType, currencyStringToNumber } from 'Helpers'

export const isDisableButton = (
	requiredFields: string[],
	values: FormValues,
	errors: FormErrors
): boolean => {
	remove(requiredFields, (item) => item === FieldNames.REPUTATION)

	return !checkRequiredFields(values, requiredFields) || formErrorState(errors)
}

export const getBgIdFromLocation = (mainUrl: string) => {
	const path = window.location.pathname
	if (path.indexOf(mainUrl) + 1) return Number(path.split('/').pop() || 0)
	return null
}

export class UploadSetting {
	// TODO пернести класс и переделать настройки для полей
	public accepted: string
	public maxSize: number
	public isDragAndDrop: boolean

	public constructor(accepted: string, maxSize: number, isDragDrop?: boolean) {
		this.accepted = accepted
		this.maxSize = maxSize
		this.isDragAndDrop = Boolean(isDragDrop)
	}

	public get tooltip(): string {
		return (
			// eslint-disable-next-line
			'Можно загружать файлы не более ' +
			this.maxSize / 1024 / 1024 +
			' Мб, с расширением: ' +
			this.accepted
				?.split(',')
				.map((ext): string => ` *${ext}`)
				.join()
		)
	}
}

export const amountFixLength = (val: number, length: number) => {
	const splitted = String(val).split('.')
	if (splitted[0].length > length)
		return Number(String(val).replace(/(\d+)([\d]{1})(\.?\d+)/, '$1$3'))
	return val
}

export const normalizeAmount = (length: number) => (value: string) => {
	const val =
		decimalRounded(currencyStringToNumber(value), {
			type: DecimalRoundedType.ROUND,
		}) ?? ''
	if (!val) return val
	return amountFixLength(val, length)
}
